import { h } from 'preact';

const MenuCards = ({ items, viewAll, viewAllUrl }) => (
  <div className="pb-18">
    <div className="flex gap-10 items-center justify-center max-w-[1420px] mx-auto">
      {items.map((item) => (
        <div key={item.id}>
          <a href={item.url} className="mb-8 block">
            <img
              src={item.image}
              alt={item.title}
              className="h-[367px] object-cover block"
            />
          </a>
          <a href={item.url} className="block mb-8 heading-3">
            {item.title}
          </a>
          <a
            href={item.url}
            className="cta-primary lc:cta-secondary inline-block pb-4 hover:no-underline"
          >
            {item.btnText}
          </a>
        </div>
      ))}
    </div>
    {!!viewAll?.length && (
      <div className="pt-40 flex items-center justify-center">
        <a
          href={viewAllUrl}
          className="block mb-12 lc:button lc:button--primary-outline-black ml:cta-primary ml:uppercase"
        >
          {viewAll}
        </a>
      </div>
    )}
  </div>
);

export default MenuCards;
